import { RefObject, useEffect, useRef } from 'react';

import { useRichTextContext } from '../RichTextProvider/RichTextProvider';

export const useEditorContainer = (): RefObject<HTMLDivElement> => {
  const containerRef = useRef<HTMLDivElement>();
  const {
    editorContainer: { rect, setRect },
  } = useRichTextContext();

  useEffect(() => {
    const containerElement = containerRef.current;
    if (!containerElement) return;

    const resizeObserver = new ResizeObserver(() => {
      const updatedRect = containerElement.getBoundingClientRect();
      // INFO dummy comparison to avoid infinite loop (rect is a new object every time)
      const shouldUpdate = updatedRect.left !== rect.left || updatedRect.width !== rect.width;

      if (shouldUpdate) setRect(updatedRect);
    });

    resizeObserver.observe(containerElement);

    return (): void => resizeObserver.disconnect();
  }, [containerRef, rect, setRect]);

  return containerRef;
};
